import { FiArrowUpRight, FiCode, FiGithub } from 'react-icons/fi';
import { RESOLVE_PORTFOLIO_MEDIA_URL } from '../../../_Shared/resolveMediaUrl';

const splitStack = (stack = '') => String(stack)
    .split(/[,|·]/)
    .map((item) => item.trim())
    .filter(Boolean)
    .slice(0, 4);

export const ProjectsSection = ({ projects = [] }) => (
    <section id="proyectos" className="PB__section PB__projects_section">
        <div className="PB__projects_glow PB__projects_glow--a" aria-hidden="true" />
        <div className="PB__projects_glow PB__projects_glow--b" aria-hidden="true" />
        <div className="PB__projects_gridlines" aria-hidden="true" />

        <div className="PB__container PB__relative">
            <div className="PB__section_header PB__section_header--showcase">
                <div>
                    <h2 className="PB__section_title">proyectos <em>·</em></h2>
                </div>
            </div>

            <div className="PB__project_grid">
                {projects.map((project) => {
                    const stack = splitStack(project.stack);

                    return (
                        <article
                            className={`PB__project_card ${project.featured ? 'is-featured' : ''}`}
                            key={project.id || project.title}
                        >
                            <div className="PB__project_media">
                                {project.image ? (
                                    <img src={RESOLVE_PORTFOLIO_MEDIA_URL(project.image)} alt={project.title} />
                                ) : (
                                    <div className="PB__project_placeholder" aria-label="Proyecto sin portada"><FiCode /></div>
                                )}
                                <div className="PB__project_media_overlay" aria-hidden="true" />
                                {project.featured && <span className="PB__project_featured">Destacado</span>}
                            </div>

                            <div className="PB__project_body">
                                <div className="PB__project_stack" aria-label="Tecnologías">
                                    {stack.length > 0
                                        ? stack.map((item) => <span key={`${project.id || project.title}-${item}`}>{item}</span>)
                                        : <span>Proyecto digital</span>}
                                </div>

                                <h3>{project.title}</h3>
                                <p>{project.description}</p>

                                {(project.url || project.repository) && (
                                    <div className="PB__project_links">
                                        {project.url && (
                                            <a className="PB__project_primary" href={project.url} target="_blank" rel="noreferrer">
                                                Ver proyecto <FiArrowUpRight />
                                            </a>
                                        )}
                                        {project.repository && (
                                            <a href={project.repository} target="_blank" rel="noreferrer" aria-label={`Código de ${project.title}`}>
                                                <FiGithub />
                                            </a>
                                        )}
                                    </div>
                                )}
                            </div>
                        </article>
                    );
                })}
            </div>
        </div>
    </section>
);
